<template>
  <div id="Modalcustom">
    <div class="modal fade" id="Modal-Orange" tabindex="-1" role="dialog">
      <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content">
          <div class="modal-header bg-warning">
            <button
              type="button"
              class="close text-light"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <slot name="ContentModalOrange"></slot>
          </div>
        </div>
      </div>
    </div>
    <div class="modal fade" id="ModalBanafash" tabindex="-1" role="dialog">
      <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content">
          <div class="modal-header bg">
            <button
              type="button"
              class="close text-light"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <slot name="ContentModalBanafash"></slot>
          </div>
        </div>
      </div>
    </div>
    <div class="modal fade" id="Modal-Info" tabindex="-1" role="dialog">
      <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content">
          <div class="modal-header bg-info">
            <div class="container row">
              <div class="col-1">
                <button
                  type="button"
                  class="close"
                  data-dismiss="modal"
                  aria-label="Close"
                >
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
              <div class="col-11 text-right p-0">
                <slot name="HeaderModalInfo"></slot>
              </div>
            </div>
          </div>
          <div class="modal-body">
            <slot name="ContentModalInfo"></slot>
          </div>
        </div>
      </div>
    </div>
    <div class="modal fade" id="Modal-Success" tabindex="-1" role="dialog">
      <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content">
          <div class="modal-header gradiant-back">
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <slot name="ContentModalSuccess"> </slot>
          </div>
        </div>
      </div>
    </div>
    <div class="modal fade" id="Modal-light" tabindex="-1" role="dialog">
      <div class="modal-dialog modal-dialog-centered" role="document" >
        <div class="modal-content modal-Filters-Pro">
          <div class="modal-header d-none">
            <button
              id="BtnCloseModal"
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <slot name="ContentModalLight"></slot>
          </div>
        </div>
      </div>
    </div>
    <div class="modal fade" id="Modal-Mobile" tabindex="-1" role="dialog">
      <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content transparent">
          <div class="modal-body">
            <button
              type="button"
              class="close text-light float-left mt-2 ml-2"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
            <slot name="ContentModalMobile"></slot>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {};
</script>
<style scoped>
@media (min-width: 576px) {
  .modal-dialog {
    max-width: 700px;
  }
  .transparent {
    background-color: #fff0 !important;
    border: none !important;
  }
}
.modal-header {
  border-bottom: none;
}
.bg {
  background: rgb(142, 85, 1);
  background: linear-gradient(
    299deg,
    rgba(142, 85, 1, 1) 0%,
    rgba(230, 139, 3, 1) 100%
  );
}
.modal {
  margin-top: 2%;
}
.bg-warning {
  background: #fda82a !important;
}
.bg-Success {
  background: #67b221 !important;
}
.gradiant-back {
  background: rgb(60, 137, 168);
  background: linear-gradient(
    51deg,
    rgba(60, 137, 168, 1) 0%,
    rgba(23, 57, 71, 1) 100%
  );
}
</style>
